export const TERM_LIST_MODEL = [
  {
    Id: '',
    Name: '',
    Slug: '',
    PublishedOn: ''
  }
]
